var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 48,
    height: 30.8872,
    viewBox: "0 0 48 30.8872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M48 15C48 17.2091 46.2091 19 44 19H39.2017C38.1409 19 37.1235 19.4214 36.3734 20.1714L26.8281 29.7158C25.2661 31.2777 22.7339 31.2777 21.1719 29.7158L11.6266 20.1714C10.8765 19.4214 9.85913 19 8.79833 19H4C1.79086 19 0 17.2091 0 15V4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V15Z",
    fill: "#7852E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintTail);
export default __webpack_public_path__ + "static/media/hint-tail.391fb9c2edb61af4efbb65178a23846b.svg";
export { ForwardRef as ReactComponent };